var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap"},[_vm._l((_vm.list),function(item,key){return _c('div',{staticClass:"flex-center h45 w45 mr10 mb10 shadow"},[_c('img',{staticClass:"w-100 h-100",attrs:{"src":item.cover}})])}),_c('div',{staticClass:"flex-center h45 w45 shadow pointer",on:{"click":_vm.add}},[_vm._v(" + ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }